import IdleTracker from "idle-tracker";
import {mapActions, mapGetters} from "vuex";
import {IDLE_TIMEOUT} from "@/constants";

export default {
    computed: {
        ...mapGetters({
            isLoggedIn: 'e/users/isLoggedIn',
        })
    },
    methods: {
        ...mapActions({
            logout: 'e/users/logout',
        }),
    },
    data: ({
        dialogVisible: false
    }),
    created () {
        this.idleTracker = new IdleTracker({
            onIdleCallback: (e) => {
                if (e.idle && this.isLoggedIn) {
                    this.logout(true).then(()=>{
                        this.$router.push({name: 'auth.login'})
                    })
                }
            },
            timeout: IDLE_TIMEOUT,
        });
        this.idleTracker.start();
    },
    beforeDestroy() {
        this.idleTracker.end();
    }
}
